import { useEffect, useRef } from 'react';
import { useCountUp } from 'react-countup';
import './biz-count-up.scss';

type BizCountUpProps = {
	value: number;
	duration?: number;
	separator?: string;
	prefix?: string;
	suffix?: string;
	decimals?: number;
	className?: string;
	legacy?: boolean;
};

const BizCountUp = ({
	value,
	duration = 1,
	separator = ' ',
	prefix = '',
	suffix = '',
	decimals = 0,
	className = '',
	legacy = false,
}: BizCountUpProps) => {
	const countUpRef = useRef(null);

	const { update } = useCountUp({
		ref: countUpRef,
		start: 0,
		end: 0,
		duration,
		separator,
		prefix,
		suffix,
		decimals,
	});

	useEffect(() => {
		if (value !== undefined && value !== null) {
			update(value);
		}
	}, [value, update]);

	return (
		<div className={`biz-count-up ${legacy ? 'legacy' : ''} ${className}`.trim()} role='status' aria-live='polite'>
			<span 
				className='biz-count-up-value' 
				ref={countUpRef} 
				style={{ minWidth: `${(value?.toString().length ?? 1) + decimals + (decimals > 0 ? 1 : 0)}ch` }}
			></span>
		</div>
	);
};

export default BizCountUp;
